import { Loader2 } from 'lucide-react';
import { Logo } from './Logo';

export function FullScreenLoader({ message }: { message?: string }): JSX.Element {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-background p-6">
      <Logo />
      <div className="flex items-center gap-2 text-sm text-text-muted">
        <Loader2 className="h-4 w-4 animate-spin" aria-hidden />
        <span role="status">{message ?? 'Cargando...'}</span>
      </div>
    </div>
  );
}
